import $ from 'jquery';
import Numbered from 'input.numbered';
import Animation from 'modules/animation/animation';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaMainSoon',
			dom: {
				container: '.js-main-soon-container',
				close: '.js-main-soon-close',
				form: '.js-main-soon-form',
				wrapper: '.js-main-soon-wrapper',
				type: '.js-main-soon-type',
				phone: '.js-main-soon-phone',
				numbered: '#yotaMainSoonNumbered'
			},
			classes: {
				state: {
					open: 'b-main-soon_state_open',
					send: 'b-main-soon_state_send'
				},
				field: {
					state: {
						error: 'b-field_state_error'
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.sended = false;
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {
		const self = this;
		self.$container = self.$el.find(self.options.dom.container);
		self.$close = self.$el.find(self.options.dom.close);
		self.$form = self.$el.find(self.options.dom.form);
		self.$wrapper = self.$el.find(self.options.dom.wrapper);
		self.$type = self.$el.find(self.options.dom.type);
		self.$phone = self.$el.find(self.options.dom.phone);
		self.$numbered = $(self.options.dom.numbered);
		return self;
	}

	onClick(event) {
		const self = this;
		const $target = $(event.target);
		if (!$target.is(self.$container) && !$target.closest(self.$container).length) {
			self.close();
		}
		return self;
	}

	open(type) {
		const self = this;
		self.$el
			.removeClass(self.options.classes.state.send)
			.addClass(self.options.classes.state.open);
		self.$type.val(type);
		self.numbered.setVal('');
		self.sended = false;
		return self;
	}

	close() {
		const self = this;
		self.$el.removeClass(self.options.classes.state.open);
		return self;
	}

	state(error) {
		const self = this;
		self.$numbered.parent().toggleClass(self.options.classes.field.state.error, error);
		self.$phone.val(self.$numbered.val().replace(/[^\d]/gi, ''));
		if (error) {
			self.wrapper.play('shake');
		}
		return self;
	}

	validate() {
		const self = this;
		const valid = self.numbered.validate();
		if (valid > 0) {
			self.$phone.val(self.$numbered.val().replace(/[^\d]/gi, ''));
		}
		return valid;
	}

	onSubmit(event) {
		/* eslint no-alert: 0 */
		const self = this;
		event.preventDefault();
		if (!self.sended) {
			if (self.validate() > 0) {
				self.sended = true;
				$.ajax({
					url: self.$form.attr('action'),
					type: self.$form.attr('method'),
					data: self.$form.serialize(),
					dataType: 'json',
					success: function (json) {
						if (json && json.success) {
							self.$el.addClass(self.options.classes.state.send);
						} else {
							alert(self.$form.data('error'));
						}
						self.sended = false;
					},
					error: function () {
						self.container.play('shake');
						alert(self.$form.data('error'));
						self.sended = false;
					}
				});
			} else {
				self.state(true);
			}
		}

		return self;
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();
			self.$el.on('click', self.onClick.bind(self));
			self.$close.on('click', self.close.bind(self));
			self.$form.on('submit', self.onSubmit.bind(self));

			self.wrapper = new Animation({el: self.$wrapper});
			self.container = new Animation({el: self.$container});

			self.numbered = new Numbered(self.$numbered, {placeholder: true});
			self.$numbered.on('change input focusin', self.state.bind(self, false));
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/main/soon/soon.js